import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ISelectOption } from '../../../../../../../../design/inputs/select/ISelectOption';
import { ToggleButtonsMultiSelect } from '../../../../../../../components/ToggleButtonsMultiSelect';
import { ImageSetType } from '../../../projectDetailsImages.model';
import { FilterContent } from '../FilterContent';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const ImageSetBody = observer((props: ImageFiltersFormProps): ReactElement => {
  const { t } = useTranslator();

  const handleSelectedChanged = (selected: ISelectOption<ImageSetType>[]): void => {
    props.onSetImageSets(selected.map((x) => x.value));
  };

  const options: ISelectOption<ImageSetType>[] = Object.values(ImageSetType).map((o) => ({ label: t(`image_set_options.${o}`), value: o }));

  const selectedOptions = options.filter((o) => props.imageFilters.imageSets.includes(o.value));

  return (
    <FilterContent>
      <ToggleButtonsMultiSelect<ISelectOption<ImageSetType>>
        options={options}
        values={selectedOptions}
        labelField='label'
        valueField='value'
        onSelectChange={handleSelectedChanged}
      />
    </FilterContent>
  );
});
